<template>
  <div>
    <list
      v-if="item"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      @error="loadingStatus = false"
      @succress="loadingStatus = true"
      :params="params"
    />
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  name: "products",
  props: ["id"],
  async created() {
    this.item = await this.cardContent("business/timetables", this.id);

    this.params["group_id"] = this.item["group_id"];
    this.params["discipline_id"] = this.item["discipline_id"];

    this.fields = [
      {
        key: "discipline_id",
        label: "",
        type: "hidden",
        value: this.item["discipline_id"],
        textType: "text",
      },
      {
        key: "group_id",
        label: "",
        type: "hidden",
        value: this.item["group_id"],
        textType: "text",
      },
      {
        col: "col-12 col-md-4 col-xl-3",
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
      },
      {
        col: "col-12 col-md-4 col-xl-3",
        label: "Выберите день",
        key: "timetable",
        type: "select",
        selectKey: "date",
        modal: "timetable",
        pushLink: `/${this.item["group_id"]}/journals/${this.item["discipline_id"]}/timetables`,
        prefix: "timetable",
      },
      {
        col: "col-12 ",
        key: "files",
        label: "Загрузите  файлы",
        type: "files",
      },
    ];
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
    cardContent: cardContent,
  },
  data() {
    return {
      params: {},
      item: null,
      loadingStatus: null,
      val: [],
      modalCreate: "item_homework",
      fields: [],
      /** APIs */
      removeLink: "business/homework",
      cardLink: "item_homework",
      itemLink: "business/homework",
      setLink: "business/homework",
      columns: [
        {
          key: "title",
          title: "Название",
        },
        {
          key: "timetable",
          object: "date",
          disableLink: true,
          dateFormat: true,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
